export class EnvService {
    public baseUrl = '';
    public serviceType = '';
    public utilityType = '';
    public PMType = '';
    public TPType = '';
    public IVType = '';
    public enableAmountChange;
    public noteBeforePayBtn = '';
    public unitZeroMessage = '';
    public minAmountMsg = '';
    public maxAmountMsg = '';
    public dashboardNoteText = '';
    public showNoteBeforePayBtn;
    public billtypeBaseUrl: any = {
        Service: {
            CompCode: '',
            URL: ''
        },
        Utility: {
            CompCode: '',
            URL: ''
        },
        IUS: {
            CompCode: '',
            URL: ''
        },
        PM: {
            CompCode: '',
            URL: ''
        }
    };
    public fmOrderType: any = {
        Callout: {
            Text: '',
            TextEn: '',
        },
        Moveout: {
            Text: '',
            TextEn: '',
        },
        Quotation: {
            Text: '',
            TextEn: '',
        },
    };
    public footers: any = {
        _800TEK: {
            ShowHomeButton: '',
            Note: ''
        },
    };
    public CustomerPortalURL = '';
    constructor() {

    }

}